import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Bank, OnboardingData } from '@zero/shared/util-models';
import { BankAccountInformation } from '../entities/bank-account-information';
import { Branch } from '../entities/branch';
import { Country } from '../entities/country.entity';
import { NationalityTaxAndEmploymentInformation } from '../entities/nationality-tax-and-employment-information';
import { PersonalInformation } from '../entities/personal-information';
import { ProvisionInformation } from '../entities/provision-information';
import { ResidenceInformation } from '../entities/residence-information';

export const onboardingActions = createActionGroup({
  source: 'Onboarding',
  events: {
    'Set Step': props<{ step: number }>(),
    'Go To Step': props<{ step: number }>(),
    'Go To Next Step': emptyProps(),
    'Go To Previous Step': emptyProps(),
    'Set Step Done': emptyProps(),
    'Send Email': props<{ email: string }>(),
    'Sign Up': props<{ password: string }>(),
    'Send Confirmation Data': props<{ email: string; code: string; adAgreed: boolean }>(),
    Login: props<{ email: string; password: string }>(),
    'Load Onboarding Data': emptyProps(),
    'Send Phone Number': props<{ phoneNumber: string }>(),
    'Check Phone Number Verified': emptyProps(),
    'Clear Phone Number Error': emptyProps(),
    'Verify Code': props<{ code: string }>(),
    'Reset Sent Code Successfully': emptyProps(),
    'Resend Code': emptyProps(),
    'Send Initial Deposit': props<{ amount: number }>(),
    'Do Initial Deposit Later': emptyProps(),
    'Send Personal Information': props<{ personalInformation: PersonalInformation }>(),
    'Send Residence Information': props<{ residenceInformation: ResidenceInformation }>(),
    'Clear Bank Data': emptyProps(),
    'Load Bank By Iban': props<{ iban: string }>(),
    'Send Bank Account Information': props<{ bankAccountInformation: BankAccountInformation }>(),
    'Load Branches': emptyProps(),
    'Send Nationality Tax And Employment Information': props<{
      nationalityTaxAndEmploymentInformation: NationalityTaxAndEmploymentInformation;
    }>(),
    'Send Provision Information': props<{ provisionInformation: ProvisionInformation }>(),
    'Load Countries': emptyProps(),
    'Delete All Data': emptyProps(),
  },
});

export const onboardingApiActions = createActionGroup({
  source: 'Onboarding API',
  events: {
    'Send Email Success': props<{ email: string }>(),
    'Send Email Failure': props<{ error: string }>(),
    'Sign Up Success': emptyProps(),
    'Sign Up Failure': props<{ error: string }>(),
    'Send Confirmation Data Success': emptyProps(),
    'Send Confirmation Data Failure': props<{ error: string }>(),
    'Login Success': emptyProps(),
    'Login Failure': props<{ error: string }>(),
    'Load Onboarding Data Success': props<{ onboardingData: OnboardingData }>(),
    'Load Onboarding Data Failure': props<{ error: string }>(),
    'Send Phone Number Success': props<{ onboardingData: OnboardingData }>(),
    'Send Phone Number Failure': props<{ error: string }>(),
    'Check Phone Number Verified Success': props<{ isPhoneNumberVerified: boolean }>(),
    'Check Phone Number Verified Failure': props<{ error: string }>(),
    'Verify Code Success': emptyProps(),
    'Verify Code Failure': props<{ error: string }>(),
    'Resend Code Success': emptyProps(),
    'Resend Code Failure': props<{ error: string }>(),
    'Send Initial Deposit Success': props<{ onboardingData: OnboardingData }>(),
    'Send Initial Deposit Failure': props<{ error: string }>(),
    'Send Personal Information Success': props<{ onboardingData: OnboardingData }>(),
    'Send Personal Information Failure': props<{ error: string }>(),
    'Send Residence Information Success': props<{ onboardingData: OnboardingData }>(),
    'Send Residence Information Failure': props<{ error: string }>(),
    'Load Bank By Iban Success': props<{ bank: Bank }>(),
    'Load Bank By Iban Failure': props<{ error: string }>(),
    'Send Bank Account Information Success': props<{ onboardingData: OnboardingData }>(),
    'Send Bank Account Information Failure': props<{ error: string }>(),
    'Load Branches Success': props<{ branches: Branch[] }>(),
    'Load Branches Failure': props<{ error: string }>(),
    'Send Nationality Tax And Employment Information Success': props<{ onboardingData: OnboardingData }>(),
    'Send Nationality Tax And Employment Information Failure': props<{ error: string }>(),
    'Send Provision Information Success': props<{ onboardingData: OnboardingData }>(),
    'Send Provision Information Failure': props<{ error: string }>(),
    'Load Countries Success': props<{ countries: Country[] }>(),
    'Load Countries Failure': props<{ error: string }>(),
    'Delete All Data Success': emptyProps(),
    'Delete All Data Failure': props<{ error: string }>(),
  },
});
